import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <div className="text-6xl font-bold tabular-nums">404</div>
      <p className="text-sm text-[color:var(--text-muted)]">页面不存在</p>
      <Link to="/">
        <Button>返回首页</Button>
      </Link>
    </div>
  );
}
